import { getAdminData } from 'app/providers/auth-provider';
import {
  Button,
  DateField,
  FunctionField,
  Loading,
  Show,
  SimpleShowLayout,
  TextField,
  useGetOne,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import { AdminSessionBalanceResponseDto } from 'shared/api';
import { API_BASE_URL_ADMIN } from 'shared/config';
import { LABELS } from 'shared/constants/labels';
import { httpClient } from 'shared/services/http-client';

export const SessionBalanceShow = () => {
  const { id } = useParams<{ id: any }>();
  const redirect = useRedirect();
  const notify = useNotify();
  const { userRole } = getAdminData();

  const isSuperadmin = userRole === 'superadmin';

  const { data: sessionBalanceData, isLoading: isSessionBalanceLoading, error: sessionBalanceError } = useGetOne<AdminSessionBalanceResponseDto>(
    'session-balances',
    { id },
    { onError: () => redirect('/b2b/companies') },
  );

  const deleteSessionBalance = async () => {
    try {
      await httpClient(`${API_BASE_URL_ADMIN}/session-balances/${id}`, {
        method: 'DELETE',
      });
  
      notify('Баланс консультаций удален', { type: 'success' });
      redirect('/b2b/companies');
    } catch (error: any) {
      notify(error.message, { type: 'error' });
    }
  };

  if (isSessionBalanceLoading) {
    return <Loading />;
  }

  if (sessionBalanceError) {
    return (
      <p>
        Произошла ошибка при загрузке данных:
      </p>
    );
  }

  if (!sessionBalanceData) {
    return <p>Данные отсутствуют.</p>;
  }

  const pageTitle = `Баланс консультаций ${sessionBalanceData.id}`;

  return (
    <Show title={pageTitle}>
      <SimpleShowLayout>
        <TextField source="id" label={LABELS.sessionBalanceId} />
        <FunctionField
          label={LABELS.sessionBalanceStatus}
          render={(record: AdminSessionBalanceResponseDto) => {
            switch (record.status) {
              case 'used':
                return 'Использовано';
              case 'unused':
                return 'Доступно';
              case 'expired':
                return 'Истек';
              case 'not_started':
                return 'Не доступно';
              default:
                return 'Неизвестно';
            }
          }}
        />
        <DateField source="startWith" label={LABELS.sessionBalanceStartWith} />
        <DateField source="endWith" label={LABELS.sessionBalanceEndWith} />
        <DateField source="createdAt" label={LABELS.createdAt} />
        <TextField source="adminName" label={LABELS.promocodeCreatorName} />
        <FunctionField
          label={LABELS.email}
          render={(record: AdminSessionBalanceResponseDto) => record.user.email}
        />
        <FunctionField
          label={LABELS.roleGroup}
          render={(record: AdminSessionBalanceResponseDto) => `${record.user.role || '-'}/${record.user.group || '-'}`}
        />
        <Button color="primary" label="Удалить" onClick={deleteSessionBalance} disabled={!isSuperadmin} />
      </SimpleShowLayout>
    </Show>
  );
};